// extracted by mini-css-extract-plugin
module.exports = {"iconFontReload":"iconFontReload--NFwT4","iconFontStop":"iconFontStop--I31At","iconFontStart":"iconFontStart--sxeLg","queryInput":"queryInput--TFYvD","form":"form--_HmAL"};